// DS7.5M
import React from 'react';
import c from 'classnames';
import s from './PromoBannerMobile.scss';
const PromoBannerMobile = ({ className, variant, message })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], s[`variant-${variant}`], className)
    }, message);
};
PromoBannerMobile.displayName = 'PromoBannerMobile';
export default PromoBannerMobile;

//# sourceMappingURL=PromoBannerMobile.js.map